RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const DISCONNECT_COMPANY_ID = 0;
    const DISCONNECT_OPTGROUP = 1;
    const COMPANIES_OPTGROUP = 2;
    const MIN_MODAL_DURATION = 1000;

    views.LinkedInPresenceConfigurationForm = Marionette.LayoutView.extend({
        template: '#linkedInPresenceConfigurationFormTemplate',

        ui: {
            saveBtn: '.x-save',
            info: '.fa-info-circle',
            companyDropdown: 'select[name="company-select"]'
        },


        behaviors: {
            AttributeBuilder: {}
        },

        events: {
            'change @ui.companyDropdown': 'onCompanyChanged'
        },

        initialize: function () {
            const me = this;

            me.accountPresences = me.options.accountPresences;
            me.accountCompanies = me.options.accountCompanies;
            me.model = me.options.model;
        },

        onRender: function () {

            const me = this;
            me.ui.info.popover();
        },

        onAttach: function () {
            const me = this;

            let options = _.map(me.accountCompanies, function (company) {
                company.optgroup = COMPANIES_OPTGROUP;
                return company;
            });
            options = _.sortBy(options, 'name');

            _.each(me.accountPresences.toJSON(), function (presence) {
                const selectOptions = _.cloneDeep(options);
                // Disconnect settings
                const disconnectName = (presence.companyId ? 'Disconnect Company' : 'Select Company');
                selectOptions.unshift({
                    id: DISCONNECT_COMPANY_ID,
                    name: disconnectName,
                    optgroup: DISCONNECT_OPTGROUP
                });

                const selectize = me.$(`select[presence-select="${presence.id}"]`).selectize({
                    optgroups: [
                        {
                            value: DISCONNECT_OPTGROUP,
                            label: ''
                        },
                        {
                            value: COMPANIES_OPTGROUP,
                            label: ''
                        }
                    ],
                    options: selectOptions,
                    render: {
                        item: metricRender,
                        option: metricRender
                    },
                    valueField: 'id',
                    labelField: 'name',
                    searchField: 'name',
                    wrapperClass: 'riq-select',
                    inputClass: 'riq-select-input',
                    dropdownClass: 'riq-select-dropdown',
                    dropdownContentClass: 'riq-select-dropdown-content'
                });

                if (presence.companyId) {
                    selectize[0].selectize.setValue(presence.companyId, true);
                } else {
                    // set disconnect option
                    selectize[0].selectize.setValue(0, true);
                }
            });
        },

        onCompanyChanged: function (e) {
            const me = this;
            const target = me.$(e.target);

            // re-render as the list of companies available to a presence varies (the presence is allowed to keep
            // the company that is currently assigned to it).
            me.changedPresenceId = parseInt(target.attr('presence-select'));
            me.changedCompanyId = parseInt(target.val());

            // selected disconnect text changed to Disconnect Company presence is unmapped
            if (me.changedCompanyId === DISCONNECT_COMPANY_ID) {
                const selectGroup = target.siblings('.riq-select');
                selectGroup.find('.riq-select-input span').text('Disconnect Company');
            }

            me.trigger('company:changed');
        },

        templateHelpers: function () {
            const me = this;

            const sortedPresences = _.orderBy(me.accountPresences.toJSON(), function (p) {
                return (p.name ? p.name.toLowerCase() : '');
            });

            return {
                accountPresences: sortedPresences,
                accountCompanies: me.accountCompanies
            };
        }
    });

    views.LinkedInPresenceConfiguration = Marionette.LayoutView.extend({
        template: '#linkedInPresenceConfigurationTemplate',

        regions: {
            form: '.x-form-region'
        },

        ui: {
            saveBtn: '.x-save'
        },

        events: {
            'click @ui.saveBtn': 'onSave'
        },

        initialize: function () {
            const me = this;

            if (me.options.linkedInPresences && me.options.unassociatedPresences) {
                me.accountPresences = me.privateMetadataToAccountPresence({
                    linkedInPresences: me.options.linkedInPresences,
                    unassociatedPresences: me.options.unassociatedPresences
                });
            } else {
                me.accountPresences = me.options.accountPresences;
            }
            me.accountCompanies = me.options.accountCompanies;
            me.fromConnectedAccounts = me.options.fromConnectedAccounts;
        },

        privateMetadataToAccountPresence: function (metadata) {
            // from private filters._linkedinProcessMetadata
            const accountPresences = _.map(metadata.linkedInPresences, function (company) {
                return _.extend({}, company, {
                    id: company.joinId,
                    companyId: company.id,
                    linked_in_presence_id: company.presenceId
                });
            });

            // all presences both mapped and unassociated w valid tokens
            const allAccountPresences = _.union(accountPresences, metadata.unassociatedPresences);

            return new RivalIQ.apps.Insights.collections.LinkedInPresences(allAccountPresences);
        },

        onBeforeShow: function () {
            const me = this;

            const validAccountPresences = _.filter(me.accountPresences?.toJSON(), function (model) {
                const validToken = _.get(model, ['sources', RivalIQ.enums.sources.LINKEDIN, 'validToken']);
                if (validToken) {
                    return model;
                }
            });

            me.configForm = new views.LinkedInPresenceConfigurationForm({
                model: me.model,
                accountPresences: new App.collections.LinkedInPresences(validAccountPresences),
                accountCompanies: me.accountCompanies
            });

            me.listenTo(me.configForm, 'company:changed', me.onCompanyChanged);

            me.form.show(me.configForm);
        },

        onShow: function () {
            const me = this;

            me.onCompanyChanged();
        },

        onCompanyChanged: function () {
            const me = this;
            const presenceId = _.get(me.configForm, 'changedPresenceId');
            const companyId = _.get(me.configForm, 'changedCompanyId');

            if (presenceId) {
                me.setDirtyModel(presenceId);

                _.each(me.accountPresences.toJSON(), function (p) {
                    // unlink dropdowns (presences with valid tokens) with dupe company linked
                    const selected = me.$(`select[presence-select="${p.id}"]`);
                    if (selected && selected[0]) {
                        const valueSelected = selected[0].selectize.getValue();
                        if (companyId === Number(valueSelected) && p.id !== presenceId) {
                            me.$(`select[presence-select="${p.id}"]`)[0].selectize.setValue(0, true);
                            me.setDirtyModel(p.id);
                        }
                    }

                    // unlink presences with invalid tokens as well (avoid DB collision)
                    const sameCompanyIdPresence = _.find(me.accountPresences.models, function (pm) {
                        return pm.get('companyId') === companyId && !pm.get('sources')[RivalIQ.enums.sources.LINKEDIN].validToken;
                    });
                    if (sameCompanyIdPresence) {
                        sameCompanyIdPresence.set('dirty', true);
                        sameCompanyIdPresence.set('companyId', null);
                    }
                });
            }
        },

        setDirtyModel: function (presenceId) {
            const me = this;

            const presenceModel = _.find(me.accountPresences.models, function (presence) {
                return presence.get('id') === presenceId;
            });
            presenceModel.set('dirty', true);
        },

        updatePresence: function (presences, btn) {
            const me = this;
            btn.button('loading');
            let firstPresenceId = '';

            presences = _.map(presences, function (presence) {
                const company_id = parseInt(me.$(`select[presence-select="${presence.id}"]`).val());
                // company_id is undefined if the dropdown isn't on the page (invalid token)
                presence.company_id = (company_id || DISCONNECT_COMPANY_ID);
                if (company_id && !firstPresenceId) {
                    firstPresenceId = presence.joinId || presence.id;
                }

                const result = _.pick(presence, ['presenceId', 'company_id']);
                result.id = presence.joinId || presence.id;
                return result;
            });

            let startTime;
            $.ajax({
                url: '/api/insights/linkedin/updatepresences',
                type: 'PUT',
                beforeSend: function (request, settings) {
                    startTime = new Date().getTime();
                },
                data: {
                    landscapeId: RivalIQ.state.landscape.id,
                    presences: presences
                },
                success: function () {
                    if (me.fromConnectedAccounts) {
                        const timeToCompleteInMs = new Date().getTime() - startTime;
                        // this call can be super fast or take a second depending on num presences to update
                        // wait a little bit so the modal doesn't disappear too fast
                        if (timeToCompleteInMs > MIN_MODAL_DURATION) {
                            me.destroy();
                        } else {
                            setTimeout(function () {
                                me.destroy();
                            }, (MIN_MODAL_DURATION - timeToCompleteInMs));
                        }
                    } else {
                        if (!me.options.noNavigate) {
                            RivalIQ.execute('history:navigate', `insights/linkedin/${firstPresenceId}`);
                        }
                        window.location.reload();
                    }
                },
                error: function () {
                    RivalIQ.execute('alert:warning', 'An error occurred, please try again');
                    btn.button('reset');
                }
            });
        },

        onSave: function () {
            const me = this;

            const dirtyPresences = _.filter(me.accountPresences.toJSON(), {
                dirty: true
            });

            if (!dirtyPresences.length) {
                return;
            }

            me.updatePresence(dirtyPresences, me.ui.saveBtn);
        }
    });

    views.LinkedInPresenceConfigurationModal = views.LinkedInPresenceConfiguration.extend({
        template: '#linkedInPresenceConfigurationModalTemplate',

        modelEvents: {
            'sync': 'onSync'
        },

        className: 'linked-in-modal',

        onSync: function () {
            const me = this;
            me.$('.modal').modal('hide');
        }
    });

    function metricRender(item) {
        return `<div><span>${_.escape(item.name)}</span></div>`;
    }
});
